import React, { useMemo, useState } from 'react';
import { FinalEnPlain } from '../../components/mobile/mobileFinalEnPlain';
import { VideoPopUp } from '../../components/mobile/videoPopUp';
import { MobileSwitchTable } from '../../components/mobile/switchTable';
import { LastResults } from '../../components/mobile/lastResults';
import { BetInfo } from '../../components/mobile/betInfo';
import { MobileRectangleTable } from '../../components/mobile/rectangleTable';
import { MobileChipSection } from '../../components/mobile/mobileChipSection';
import { OptionalBet } from '../../components/mobile/optionalBet';
import OvalTable from '../../components/ovalTable';
import { TableTypes } from '../../enums/tableTypes';
import { winningAmountStore } from '../../store/winningAmountStore';
import WinNumbers from '../../components/winNumbers';
import { winNumbersColor } from '../../helpers/winNumbersColor';
import { observer } from 'mobx-react-lite';
import { FreeBetsWrapper } from '@pascal/pascal-core';

export const MobileGameMain = observer(({ isReplay }) => {
  const [mainTableType, setMainTableType] = useState(TableTypes.Rectangle);
  const [isShowBetActionModal, setIsShowBetActionModal] = useState(false);
  const { winNumber, getWinningAmount: winningAmount } = winningAmountStore;

  const winNumbersResult = useMemo(() => {
    return winNumbersColor(winNumber);
  }, [winNumber]);

  return (
    <div className='roulette-mobile-wrapper'>
      <FreeBetsWrapper />
      {!isReplay && (
        <div className='roulette-mobile-top'>
          <BetInfo />
          <LastResults isShowBetActionModal={isShowBetActionModal} setIsShowBetActionModal={setIsShowBetActionModal} />
          {winNumbersResult && <WinNumbers winNumbersResult={winNumbersResult} winningAmount={winningAmount} />}
        </div>
      )}
      <div className='roulette-mobile-middle'>
        <div className='mob-roulette-t-holder'>
          {!isReplay && (
            <>
              <OptionalBet />
              <MobileChipSection />
            </>
          )}
          <MobileSwitchTable mainTableType={mainTableType} setMainTableType={setMainTableType} />
          <VideoPopUp />
          {!isReplay && <FinalEnPlain />}
          {/*add/remove open class*/}
          {mainTableType === TableTypes.Rectangle ? (
            <MobileRectangleTable />
          ) : (
            <div className='mob-oval-roulette'>
              <OvalTable handleMouseMove={() => {}} handleMouseLeave={() => {}} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
});
